export default "__VITE_ASSET__B39C0vVP__"